module.exports = __webpack_public_path__ + "static-m/img/miniLogo.97db9824.jpg";